import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { PaperPromo } from './PaperPromo'

export const PaperPromoRegistration = createRegisterableComponent(
    'paper-promo',
    () => {
        return <PaperPromo />
    },
)
